import {useAppSelector} from "./reduxHooks.ts";
import {type UserType} from "../model/user/UserScope.ts";

interface GarageScope {
    type: UserType | undefined;
    garageNo: string | undefined;
    garageGroupNo: string | undefined;
    isAdmin: boolean;
    isGroup: boolean;
    isGarage: boolean;
}

/**
 * Reads the auth user scope and exposes the common derived fields.
 * Replaces a ~10-call duplication of `useAppSelector(state => state.auth.userScope?.garageNo?.index)`.
 */
export const useGarageScope = (): GarageScope => {
    const userScope = useAppSelector(state => state.auth.userScope);
    return {
        type: userScope?.type,
        garageNo: userScope?.garageNo?.index,
        garageGroupNo: userScope?.garageGroupNo?.index,
        isAdmin: userScope?.type === "admin",
        isGroup: userScope?.type === "group",
        isGarage: userScope?.type === "garage",
    };
};
